import { render, staticRenderFns } from "./AddReviewDatails.vue?vue&type=template&id=966e78e2&scoped=true"
import script from "./AddReviewDatails.vue?vue&type=script&lang=js"
export * from "./AddReviewDatails.vue?vue&type=script&lang=js"
import style0 from "./AddReviewDatails.vue?vue&type=style&index=0&id=966e78e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966e78e2",
  null
  
)

export default component.exports